import React from "react";
import styled from "styled-components";

const ChartContainer = styled.div`
  width: 100%;
`;

const BarContainer = styled.div`
  margin-bottom: 10px;
`;

const BarLabel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 14px;
`;

const Bar = styled.div`
  height: 30px;
  background: #4caf50;
  border-radius: 4px;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  padding: 0 10px;
  color: white;
  font-weight: bold;
  font-size: 12px;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const PopularKeywordsChart = ({ data, loading, onKeywordSelect }) => {
  if (loading) {
    return <LoadingMessage>Loading chart...</LoadingMessage>;
  }

  if (!data || data.length === 0) {
    return <LoadingMessage>No keyword data available.</LoadingMessage>;
  }

  const maxCount = Math.max(...data.map((d) => d.count), 1);

  return (
    <ChartContainer>
      {data.map((item, index) => (
        <BarContainer
          key={index}
          style={{ cursor: onKeywordSelect ? "pointer" : "default" }}
          onClick={() => onKeywordSelect && onKeywordSelect(item.keyword)}
        >
          <BarLabel>
            <span>{item.keyword || "(no keyword)"}</span>
            <span>{item.count.toLocaleString()}</span>
          </BarLabel>
          <Bar style={{ width: `${(item.count / maxCount) * 100}%` }}>
            {item.count}
          </Bar>
        </BarContainer>
      ))}
    </ChartContainer>
  );
};

export default PopularKeywordsChart;

